// Single source of truth for site navigation.
// Consumed by Header, MobileNav, and Footer so labels + hrefs stay in sync.

export type NavLink = { label: string; href: string };

export const primaryNav: NavLink[] = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Services", href: "/services" },
  { label: "Projects", href: "/projects" },
  { label: "Pricing", href: "/pricing" },
  { label: "Contact", href: "/contact" },
];

// Services dropdown — pillar service first
export const servicesDropdown: NavLink[] = [
  { label: "Clothing Brand Startup", href: "/services/clothing-brand-startup" },
  { label: "Logo Branding & Identity", href: "/services/logo-branding" },
  { label: "SEO for Clothing Brands", href: "/services/seo" },
  { label: "Content Writing", href: "/services/content-writing" },
];

// Footer columns
export const footerServices: NavLink[] = servicesDropdown;

export const footerCompany: NavLink[] = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Projects", href: "/projects" },
  { label: "Pricing", href: "/pricing" },
  { label: "Blog", href: "/blog" },
  { label: "FAQs", href: "/faqs" },
];

export const footerSupport: NavLink[] = [
  { label: "Contact", href: "/contact" },
  { label: "Terms & Conditions", href: "/terms" },
  { label: "Privacy Policy", href: "/privacy" },
];

// Contact details — sourced from docs/content/contact.md
export const contact = {
  email: "hello@okpromo.co.uk",
  phoneMobile: "+44 7403 343 433",
  phoneMobileHref: "tel:+447403343433",
  phoneLandline: "0121 725 8280",
  phoneLandlineHref: "tel:+441217258280",
  address: "126 Beeches Road, Birmingham",
};

// Social links — sourced from docs/content/footer.md
export const social = [
  { label: "Facebook", href: "https://facebook.com/OKPromoSolutions" },
  { label: "Instagram", href: "https://instagram.com/OKPromoSolutions" },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/okpromosolutions" },
];

// CTA used in header + footer + mobile nav
export const primaryCta: NavLink = { label: "Get In Touch", href: "/contact" };
